import * as QuotaApi from '@wix/ambassador-innovation-assistant-v2-quota/http';

import { createAppAsyncThunk } from '../createAppAsyncThunk';

import { toConversationsQuota } from './model';
import { shouldLoad as selectShouldLoad } from './conversationsQuotaSelectors';

export const getConversationsQuota = createAppAsyncThunk(
  'chat/getConversationsQuota',
  async (_, { extra: { httpClient: client } }) => {
    const {
      data: { quota },
    } = await client.request(QuotaApi.getQuota({}));

    return toConversationsQuota({
      quota: quota?.conversations?.limit,
      current: quota?.conversations?.used,
      available: quota?.conversations?.available,
    });
  },
);

export const getConversationsQuotaThrottled = createAppAsyncThunk(
  'chat/getConversationsQuota/throttled',
  (_, { dispatch, getState }) => {
    const shouldLoad = selectShouldLoad(getState());

    if (shouldLoad) {
      return dispatch(getConversationsQuota());
    }
  },
);
